import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalOpenerService, WithSubscriptionComponent } from '@sabstravtech/obtservices/angular';
import { ModalEvent } from '@sabstravtech/obtservices/base';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-opener',
  templateUrl: './modal-opener.component.html',
  styleUrls: ['./modal-opener.component.scss'],
  standalone: false
})
export class ModalOpenerComponent extends WithSubscriptionComponent implements OnInit, OnDestroy {
  private subscription: Subscription = null;
  constructor(
    private modalOpenerService: ModalOpenerService,
    private modalService: NgbModal
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscription = this.modalOpenerService.subscribe((event: ModalEvent) => {
      const modal: any = event.type.component;
      if (modal) {
        const instance = this.modalService.open(modal, event.options);
        Object.keys(event.data || {}).forEach((key: string) => {
          if (instance.componentInstance.hasOwnProperty(key)) {
            instance.componentInstance[key] = event.data[key];
          }
        });
        if (event.results) {
          instance.result.then(event.results).catch(() => {
            event.results(null);
          });
        }

        instance.shown.subscribe(() => {
          setTimeout(() => {
            const modalWindows = document.querySelectorAll('ngb-modal-window.show');
            const modalWindow = modalWindows.length
              ? (modalWindows[modalWindows.length - 1] as HTMLElement)
              : null;
            if (modalWindow && !modalWindow.contains(document.activeElement)) {
              const autoFocusable = modalWindow.querySelector('[ngbAutofocus]') as HTMLElement;
              const firstFocusable = modalWindow.querySelector(
                'button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
              ) as HTMLElement;
              const target = autoFocusable || firstFocusable || modalWindow;
              target?.focus();
            }
          }, 50);
        });
      } else {
        console.warn('Unable to find Modal : ' + event.type);
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }
}
